exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_wks-ext.js
// module id = 234
// module chunks = 4